import { COMPONENT_TYPES } from '../constants/gridConfig';
import { generateCacheKey, getCachedProps } from './propsCache';

/**
 * Get dynamic props overrides for different component types
 * @param {string} componentName - Component name
 * @param {string} displayName - Component display name
 * @param {Object} props - Base props
 * @param {string} imageUrl - Image URL
 * @param {Array} markersData - Markers data
 * @param {Object} planData - Plan data
 * @param {Object} legacySignage - Legacy signage data
 * @returns {Object} Props overrides
 */
export const getDynamicPropsOverrides = (componentName, displayName, props, imageUrl, markersData, planData, legacySignage, categoriesData, shortName) => {
  const cacheKey = generateCacheKey(displayName, markersData, planData, legacySignage);
  
  return getCachedProps(cacheKey, () => {
    const overrides = {};
    
    switch (displayName) {
      case COMPONENT_TYPES.FLOOR_PLAN:
        if (planData?.rawUrl) overrides.src = planData.rawUrl;
        if (planData?.width) overrides.imageWidth = planData.width;
        if (planData?.height) overrides.imageHeight = planData.height;
        if (markersData.length > 0) overrides.markers = markersData;
        break;
        
      case COMPONENT_TYPES.TIME_COMPONENTS[0]:
      case COMPONENT_TYPES.TIME_COMPONENTS[1]:
      case COMPONENT_TYPES.TIME_COMPONENTS[2]:
        // Time data now handled by TimeIsolatedWrapper - no overrides needed here
        break;
        
      case COMPONENT_TYPES.BUILDING_INFO:
        overrides.children = legacySignage?.address;
        break;
        
      case COMPONENT_TYPES.SPACE_CATEGORY:
        // Provide categories data and dates array for Space Category component
        if (categoriesData && categoriesData.length > 0) {
          overrides.categories = categoriesData;
        }
        if (shortName) {
          overrides.dates = [shortName];
        }
        
        console.log(`📊 Space Category props override:`, {
          displayName,
          categories: overrides.categories,
          dates: overrides.dates,
          categoriesCount: categoriesData?.length || 0,
          shortName,
          timestamp: new Date().toISOString()
        });
        break;
        
      default:
        break;
    }
    
    return overrides;
  });
};

/**
 * Check if component is time-dependent
 * @param {string} displayName - Component display name
 * @returns {boolean} True if component is time-dependent
 */
export const isTimeComponent = (displayName) => {
  return COMPONENT_TYPES.TIME_COMPONENTS.includes(displayName);
};

/**
 * Check if component uses markers
 * @param {string} displayName - Component display name
 * @returns {boolean} True if component uses markers
 */
export const componentUsesMarkers = (displayName) => {
  return displayName === COMPONENT_TYPES.FLOOR_PLAN;
};
